setTimeout(() => {
    if(BSS_B2B){
        const modal = document.querySelector(".modal[data-trap-focus]");
        if(modal){
            const observer = new MutationObserver((MutationList) => {
                for(let item of MutationList){
                    if(item.target.className.includes('modal-inner') && item.type === "attributes"){
                        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                    }
                }
            })
            observer.observe(modal, {attributes: true, childList: true, subtree: true})
        }
    }
}, 300)


document.addEventListener("click", function (e) {
    const btn = e.target.closest(".b2b-nt-button-continue");
    if (!btn) return;

    const firstName = document.querySelector(".first-name");
    const lastName = document.querySelector(".last-name");
    const address = document.querySelector(".address-field");
  if (apartment && apartment.value.trim() !== "") {
    validate(apartment, addressApartmentRegex, "Kun bokstaver og tall er tillatt");
} else {
    clearError(apartment);
}

    const city = document.querySelector(".city-field");
    const country = document.querySelector(".country-name");
    const zip = document.querySelector(".zip-field");

    const textOnlyRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
    const numberOnlyRegex = /^[0-9]+$/;
    const addressApartmentRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s,.\-\/#]+$/;

    let hasError = false;

    function validate(input, regex, message) {
        if (!input || !regex.test(input.value.trim())) {
            showError(input, message);
            hasError = true;
        } else {
            clearError(input);
        }
    }

    validate(firstName, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(lastName, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(address, addressApartmentRegex, "Kun bokstaver og tall er tillatt");
    validate(apartment, addressApartmentRegex, "Kun bokstaver og tall er tillatt");
    validate(city, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(country, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(zip, addressApartmentRegex, "Kun bokstaver og tall er tillatt");

    if (hasError) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }
}, true);


const cartSize = BSS_B2B.storage.cartStorage.store.size;
if(cartSize == 0 ) {
        document.querySelectorAll("#bss-b2b-net-term-button").forEach(btn => {
        btn.style.display = "none";
    });
}

function showError(input, message) {
    if (!input) return;

    let error = input.nextElementSibling;
    if (!error || !error.classList.contains("bss-message")) {
        error = document.createElement("span");
        error.className = "bss-message";
        input.insertAdjacentElement("afterend", error);
    }

    error.textContent = message;
    error.style.setProperty("color", "red", "important");
}


function clearError(input) {
    if (!input) return;

    const error = input.parentElement.querySelector(".bss-message");
    if (error) error.remove();
}

document.addEventListener("click", function (e) {
    const btn = e.target.closest(".b2b-nt-button-continue");
    if (!btn) return;

    const firstName = document.querySelector(".first-name");
    const lastName = document.querySelector(".last-name");
    const address = document.querySelector(".address-field");
    const country = document.querySelector(".country-name");
    const apartment = document.querySelector(".apartment-field");
    const city = document.querySelector(".city-field");
    const zip = document.querySelector(".zip-field");
    

    const textOnlyRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
    const numberOnlyRegex = /^[0-9]+$/;
    const addressRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s,.\-\/]+$/;
    const addressApartmentRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s,.\-\/#]+$/;


    let hasError = false;

    function validate(input, regex, message) {
        if (!input || !regex.test(input.value.trim())) {
            showError(input, message);
            hasError = true;
        } else {
            clearError(input);
        }
    }

    validate(firstName, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(lastName, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(company, addressApartmentRegex, "Kun bokstaver er tillatt");
    validate(country, textOnlyRegex, "Kun bokstaver er tillatt");
    validate(postalCode, addressApartmentRegex, "Kun tall er tillatt");
    validate(organizationNumber, numberOnlyRegex, "Kun tall er tillatt");
    validate(addressCompany, addressRegex, "Kun bokstaver og tall er tillatt");

    if (hasError) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }

    let counter = 0;
    const interval = setInterval(() => {
        const label0 = document.querySelector('label[for="b2b-nt-shipping-method-option-0"]');
        const label1 = document.querySelector('label[for="b2b-nt-shipping-method-option-1"]');

        if (label0 && label1) {
            label0.innerText = "Pakke på dør";
            label1.innerText = "Post i butikk";
            clearInterval(interval);
        }

        counter += 100;
        if (counter >= 10000) clearInterval(interval);
    }, 100);
},true);
